export { default as PlatformsIntroSection } from './PlatformsIntroSection/PlatformsIntroSection';
export { default as PlatformsLabelsSection } from './PlatformsLabelsSection/PlatformsLabelsSection';
export { default as PlatformsComposabilitySection } from './PlatformsComposabilitySection/PlatformsComposabilitySection';
export { default as PlatformsWidgetSection } from './PlatformsWidgetSection/PlatformsWidgetSection';
